import store from '../store';
import findFormIndex from './pluralformIndex';

export default function l10n(key: string, params: {} = {}, count: Nullable<number> = null) {
   const pattern = store.getters.l10n[key] || key;
   if (!Object.keys(params).length) {
      return pattern;
   }
   if (count == null) {
      return compile(pattern, params);
   }
   const idx = store.getters.pluralRuleIndex;
   const pluralIdx = findFormIndex(idx, count);
   return compile(store.getters.l10n[`${key}#${pluralIdx}`], params);
}

interface Token {
   type: 'text' | 'named';
   value: string;
}

function toTokens(format: string): Token[] {
   const tokens: Token[] = [];
   let position: number = 0;

   let text: string = '';
   while (position < format.length) {
      let char: string = format[position++];
      if (char === '{') {
         if (text) {
            tokens.push({ type: 'text', value: text });
         }

         text = '';
         let sub: string = '';
         char = format[position++];
         while (char !== '}') {
            if (char !== '$') {
               sub += char;
            }
            char = format[position++];
         }

         tokens.push({ value: sub, type: 'named' });
      } else {
         text += char;
      }
   }

   if (text) {
      tokens.push({ type: 'text', value: text });
   }

   return tokens;
}

function compile(pattern: string, params: {}): string {
   // const pattern = translation.isPlural ? _findInPluralPattern(translation, pluralCount) : translation.value;

   return toTokens(pattern).map((token) => {
      if (token.type === 'text') {
         return token.value;
      }
      const prop = token.value;
      const value = (params as any)[prop];

      if (value == null) {
         return '';
      }

      return `${value}`;
   }).join('');
}

